import { render } from "./InfoGridRank1.vue?vue&type=template&id=4cf88508&scoped=true"
import script from "./InfoGridRank1.vue?vue&type=script&lang=js"
export * from "./InfoGridRank1.vue?vue&type=script&lang=js"

import "./InfoGridRank1.vue?vue&type=style&index=0&id=4cf88508&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf88508"]])

export default __exports__